import React from 'react';
import { capitalize, Typography, useTheme } from '@mui/material';
import { FilterOperations as FO } from 'business/definitions';
import { translateBlock } from 'i18n';
import { useTranslation } from 'react-i18next';

export const useRenderOperationValue = (
    filter: SentenceFilterT,
    isDynamicFilter: boolean,
    isPerimeterFilter: boolean,
) => {
    const { t } = useTranslation('sentence');
    const translateKey = (key: string) => t(`yearOperations.${key}`);
    const theme = useTheme();
    return (val: string) => {
        if (filter.value === null && isPerimeterFilter) {
            return (
                <Typography color={theme.palette.text.disabled}>
                    {capitalize(translateBlock(filter.field))}
                </Typography>
            );
        }
        if (isDynamicFilter) {
            const [displayedOperation, displayedValue] = val.split('-');
            const baseDynamicFilterTranslation = `${translateKey(
                displayedOperation,
            )} ${translateKey(displayedValue)}`;
            if ([FO.equal, FO.not_equal].includes(displayedOperation)) {
                return baseDynamicFilterTranslation;
            }
            return `${baseDynamicFilterTranslation} ${translateKey(
                'included',
            )}`;
        }
        return translateKey(val);
    };
};
